module.exports = __webpack_public_path__ + "static/img/hagmann.55f9361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/hagmann.jpg
// module id = 470
// module chunks = 1